module.exports = __webpack_public_path__ + "static/rice-logo-footer@2x-a0c1bfe9b75da236fc96e612e8241e07.jpg";